import { MoleculeCo2Icon } from './MoleculeCo2Icon';

/**
 * author: GreenTurtwig
 * id 6F7A0011-054A-4805-A970-A48BEAA9454B
 * name molecule-co2
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/molecule-co2.svg
 * tags
 * - Science 
 * - Home Automation 
 */
export const GasCo2Icon = MoleculeCo2Icon;
export default GasCo2Icon